import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from '../axios';

const initialState = {
   transactions : {loading: false , data : [], totalTransactions: 0},
   selectedTransaction: null,
   reprintLogs: []
};

export const getTransactions = createAsyncThunk('Transaction/getTransactions', async () => {
    try {
        const response = await axios.get(`/transaction`);
        return response.data;
    } catch (error) {
        const customError = {
            name: error.code,
            message: error.message,
        };
        throw customError;
    }
});

export const getFilteredTransactions = createAsyncThunk('Transaction/getFilteredTransactions', async (data) => {
    try {
        const response = await axios.patch(`/transaction/filter?page=${data?.page - 1}&size=${data?.pageSize}&search=${data?.search}`, data);
        return response.data;
    } catch (error) {
        const customError = {
            name: error.code,
            message: error.message,
        };
        throw customError;
    }
});

export const getSummaryTransactions = createAsyncThunk('Transaction/getSummaryTransactions', async (data) => {
    try {
        const response = await axios.patch(`/transaction/filter/totals?search=${data?.search}`, data);
        return response.data;
    } catch (error) {
        const customError = {
            name: error.code,
            message: error.message,
        };
        throw customError;
    }
});

export const updateTransactionPaymentStatus = createAsyncThunk('Transaction/updateTransactionPaymentStatus', async (data) => {
    try {
        const response = await axios.patch(`/transaction/payment-status`, data);
        return response.data;
    } catch (error) {
        const customError = {
            name: error.code,
            message: error.message,
        };
        throw customError;
    }
});

export const getTransactionById = createAsyncThunk('Transaction/getTransactionById', async (id) => {
    // try {
    //     const response = await axios.get(`transaction/${id}`);
    //     return response.data;
    // } catch (error) {
    //     const customError = {
    //         name: error.code,
    //         message: error.message,
    //     };
    //     throw customError;
    // }
});

export const getReprintLogs = createAsyncThunk('Transaction/getReprintLogs', async (transactionId) => {
    try {
        const response = await axios.get(`/reprintLogs/transaction/${transactionId}`);
        return response.data;
    } catch (error) {
        const customError = {
            name: error.code,
            message: error.message,
        };
        throw customError;
    }
});

export const transactionSlice = createSlice({
	name: 'Transaction',
	initialState,
	reducers: {},	extraReducers: {
        [getTransactions.pending]: (state, action) => {
            state.transactions.loading = true;
        },
       [getTransactions.fulfilled]: (state, action) => {
           state.transactions.data = action.payload;
           state.transactions.loading = false;
       },
       [getFilteredTransactions.pending]: (state, action) => {
        state.transactions.loading = true;
    },
       [getFilteredTransactions.fulfilled]: (state, action) => {
        state.transactions.data = action.payload.content || [];
        state.transactions.totalTransactions = action.payload?.totalElements || 0; 
                state.transactions.loading = false;
       },
       [getFilteredTransactions.rejected]: (state, action) => {
        state.transactions.loading = false;
        state.transactions.data = [];
      },
            [updateTransactionPaymentStatus.pending]: (state) => {
                state.transactions.loading = true;
            },
       [updateTransactionPaymentStatus.fulfilled]: (state, action) => {
        const updatedTransactionsRaw = action.payload;
        const updatedTransactions = Array.isArray(updatedTransactionsRaw)
            ? updatedTransactionsRaw
            : updatedTransactionsRaw
                ? [updatedTransactionsRaw]
                : [];

        const transactionsMap = new Map(
            updatedTransactions
                .filter(item => item && item.id != null)
                .map(item => [item.id, item])
        );

        const currentTransactions = Array.isArray(state.transactions.data)
            ? state.transactions.data
            : [];

        state.transactions.data = currentTransactions.map(transaction =>
            transactionsMap.has(transaction.id)
                ? { ...transaction, ...transactionsMap.get(transaction.id) }
                : transaction
        );
        state.transactions.loading = false;
       },
            [updateTransactionPaymentStatus.rejected]: (state) => {
                state.transactions.loading = false;
            },
       [getReprintLogs.fulfilled]: (state, action) => {
        state.reprintLogs = action.payload;
       },
    },
});

export default transactionSlice.reducer